import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../App';
import api from '../api';

const GUNLER = ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'];
const AYLAR = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];

function ayinGunleri(yil, ay) {
  const ilk = new Date(yil, ay, 1);
  const baslangicGun = (ilk.getDay() + 6) % 7; // Pazartesi=0
  const aySonu = new Date(yil, ay + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < baslangicGun; i++) cells.push(null);
  for (let d = 1; d <= aySonu; d++) cells.push(d);
  return cells;
}

export default function DenetimTakvimi() {
  const { kullanici } = useContext(AuthContext);
  const bugun = new Date();
  const [yil, setYil] = useState(bugun.getFullYear());
  const [ay, setAy] = useState(bugun.getMonth());
  const [denetimler, setDenetimler] = useState([]);
  const [seciliGun, setSeciliGun] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [modalAcik, setModalAcik] = useState(false);
  const [personeller, setPersoneller] = useState([]);
  const [ruhsatArama, setRuhsatArama] = useState('');
  const [ruhsatSonuc, setRuhsatSonuc] = useState([]);
  const [form, setForm] = useState({ ruhsat_id:'', atanan_personel_id:'', planlanan_tarih:'', tur:'', notlar:'' });

  useEffect(() => { yukle(); }, [yil, ay]); // eslint-disable-line
  useEffect(() => { api.get('/tanimlar/kullanicilar').then(r=>setPersoneller(r.data||[])).catch(()=>{}); }, []);

  const yukle = async () => {
    setYukleniyor(true);
    try {
      const baslangic = `${yil}-${String(ay+1).padStart(2,'0')}-01`;
      const bitis = `${yil}-${String(ay+1).padStart(2,'0')}-${new Date(yil,ay+1,0).getDate()}`;
      const r = await api.get(`/denetim?baslangic=${baslangic}&bitis=${bitis}&limit=200`);
      setDenetimler(r.data.veriler || []);
    } catch { setDenetimler([]); } finally { setYukleniyor(false); }
  };

  const gunDenetimleri = (gun) => {
    if (!gun) return [];
    const tarihStr = `${yil}-${String(ay+1).padStart(2,'0')}-${String(gun).padStart(2,'0')}`;
    return denetimler.filter(d => {
      const t = d.planlanan_tarih || d.baslangic_tarihi || d.denetim_tarihi || '';
      return t.startsWith(tarihStr);
    });
  };

  const cells = ayinGunleri(yil, ay);

  const oncekiAy = () => { if (ay === 0) { setYil(y=>y-1); setAy(11); } else setAy(a=>a-1); };
  const sonrakiAy = () => { if (ay === 11) { setYil(y=>y+1); setAy(0); } else setAy(a=>a+1); };

  const ruhsatAra = async () => {
    if (!ruhsatArama.trim()) return;
    const r = await api.get(`/ruhsat?q=${encodeURIComponent(ruhsatArama)}&limit=10`);
    setRuhsatSonuc(r.data.veriler || []);
  };

  const kaydet = async (e) => {
    e.preventDefault();
    try {
      await api.post('/denetim', form);
      yukle(); setModalAcik(false);
      setForm({ ruhsat_id:'', atanan_personel_id:'', planlanan_tarih:'', tur:'', notlar:'' });
      setRuhsatArama(''); setRuhsatSonuc([]);
    } catch (err) { alert(err.response?.data?.hata || 'Hata oluştu'); }
  };

  const durumRenk = { PLANLANDI:'#1565c0', YAPILDI:'#1b5e20', IPTAL:'#b71c1c', ERTELENDI:'#e65100' };

  const seciliGunDenetimleri = seciliGun ? gunDenetimleri(seciliGun) : [];
  const bugunGun = bugun.getFullYear()===yil && bugun.getMonth()===ay ? bugun.getDate() : null;

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'20px',flexWrap:'wrap',gap:'8px'}}>
        <div>
          <h2 style={{color:'#1a237e',fontSize:'20px'}}>📅 Denetim Takvimi</h2>
          <div style={{fontSize:'12px',color:'#888',marginTop:'2px'}}>{denetimler.length} denetim bu ay planlanmış</div>
        </div>
        <button className="btn btn-primary" onClick={()=>{setModalAcik(true);setForm(f=>({...f,planlanan_tarih:seciliGun?`${yil}-${String(ay+1).padStart(2,'0')}-${String(seciliGun).padStart(2,'0')}`:f.planlanan_tarih}));}}>
          ➕ Denetim Planla
        </button>
      </div>

      <div style={{display:'grid',gridTemplateColumns:seciliGun?'1fr 300px':'1fr',gap:'16px',alignItems:'start'}}>
        <div className="card" style={{padding:'0'}}>
          {/* Takvim başlığı */}
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'12px 16px',borderBottom:'1px solid #eee',background:'#1a237e',borderRadius:'8px 8px 0 0'}}>
            <button onClick={oncekiAy} style={{background:'none',border:'none',color:'#fff',cursor:'pointer',fontSize:'18px',padding:'4px 8px'}}>‹</button>
            <div style={{color:'#fff',fontWeight:'700',fontSize:'16px'}}>{AYLAR[ay]} {yil}</div>
            <button onClick={sonrakiAy} style={{background:'none',border:'none',color:'#fff',cursor:'pointer',fontSize:'18px',padding:'4px 8px'}}>›</button>
          </div>

          {/* Gün başlıkları */}
          <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',background:'#e8eaf6'}}>
            {GUNLER.map(g=><div key={g} style={{textAlign:'center',padding:'8px 4px',fontSize:'12px',fontWeight:'700',color:'#3949ab'}}>{g}</div>)}
          </div>

          {/* Günler */}
          {yukleniyor ? (
            <div style={{textAlign:'center',padding:'40px',color:'#888'}}>Yükleniyor...</div>
          ) : (
            <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)'}}>
              {cells.map((gun, i) => {
                const denList = gunDenetimleri(gun);
                const isToday = gun === bugunGun;
                const isSelected = gun === seciliGun;
                return (
                  <div key={i} onClick={()=>gun&&setSeciliGun(gun===seciliGun?null:gun)}
                    style={{
                      minHeight:'70px', padding:'4px 6px', borderRight:'1px solid #f0f0f0', borderBottom:'1px solid #f0f0f0',
                      background: isSelected ? '#e8eaf6' : isToday ? '#fff3e0' : gun ? '#fff' : '#fafafa',
                      cursor: gun ? 'pointer' : 'default',
                      transition: 'background 0.12s',
                    }}
                    onMouseOver={e=>gun&&!isSelected&&(e.currentTarget.style.background='#f5f5ff')}
                    onMouseOut={e=>gun&&!isSelected&&(e.currentTarget.style.background=isToday?'#fff3e0':'#fff')}>
                    {gun && (
                      <>
                        <div style={{fontSize:'13px',fontWeight:isToday?'800':'500',color:isToday?'#e65100':'#333',textAlign:'right'}}>{gun}</div>
                        {denList.slice(0,3).map((d,j)=>(
                          <div key={j} style={{fontSize:'10px',background:durumRenk[d.durum]||'#1565c0',color:'#fff',borderRadius:'2px',padding:'1px 4px',marginTop:'2px',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis'}}>
                            {d.unvan || d.ruhsat_id || 'Denetim'}
                          </div>
                        ))}
                        {denList.length > 3 && <div style={{fontSize:'10px',color:'#888',marginTop:'1px'}}>+{denList.length-3} daha</div>}
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {/* Legend */}
          <div style={{padding:'8px 16px',background:'#f8f9ff',borderTop:'1px solid #eee',display:'flex',gap:'16px',flexWrap:'wrap',borderRadius:'0 0 8px 8px'}}>
            {Object.entries(durumRenk).map(([k,v])=>(
              <div key={k} style={{display:'flex',alignItems:'center',gap:'4px',fontSize:'11px'}}>
                <div style={{width:'10px',height:'10px',borderRadius:'2px',background:v}}/>
                {k}
              </div>
            ))}
          </div>
        </div>

        {/* Seçili gün detayı */}
        {seciliGun && (
          <div className="card" style={{position:'sticky',top:'80px'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
              <strong style={{color:'#1a237e'}}>{String(seciliGun).padStart(2,'0')} {AYLAR[ay]} {yil}</strong>
              <button onClick={()=>setSeciliGun(null)} style={{background:'none',border:'none',cursor:'pointer',color:'#888',fontSize:'18px'}}>×</button>
            </div>
            {seciliGunDenetimleri.length === 0 ? (
              <div style={{color:'#aaa',fontSize:'13px',textAlign:'center',padding:'20px 0'}}>
                Bu gün denetim yok
                <br/>
                <button className="btn btn-primary btn-sm" style={{marginTop:'8px'}} onClick={()=>{setModalAcik(true);setForm(f=>({...f,planlanan_tarih:`${yil}-${String(ay+1).padStart(2,'0')}-${String(seciliGun).padStart(2,'0')}`}));}}>
                  Denetim Planla
                </button>
              </div>
            ) : (
              <div>
                {seciliGunDenetimleri.map(d=>(
                  <div key={d.id} style={{padding:'10px',background:'#f8f9ff',borderRadius:'6px',marginBottom:'8px',borderLeft:`3px solid ${durumRenk[d.durum]||'#1565c0'}`}}>
                    <div style={{fontWeight:'700',fontSize:'13px',color:'#1a237e'}}>{d.unvan || d.rn || '—'}</div>
                    {d.rn && <div style={{fontFamily:'monospace',fontSize:'11px',color:'#3949ab'}}>{d.rn}</div>}
                    {d.atanan_adi && <div style={{fontSize:'12px',color:'#555',marginTop:'4px'}}>👤 {d.atanan_adi}</div>}
                    {d.tur && <div style={{fontSize:'11px',color:'#666'}}>Tür: {d.tur}</div>}
                    <div style={{fontSize:'11px',fontWeight:'700',color:durumRenk[d.durum]||'#1565c0',marginTop:'4px'}}>{d.durum}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Yeni denetim modal */}
      {modalAcik && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'500px'}}>
            <div className="modal-header">
              <span className="modal-title">📅 Denetim Planla</span>
              <button className="modal-close" onClick={()=>setModalAcik(false)}>×</button>
            </div>
            <form onSubmit={kaydet}>
              <div className="form-group">
                <label>İşyeri / Ruhsat *</label>
                <div style={{display:'flex',gap:'8px'}}>
                  <input value={ruhsatArama} onChange={e=>setRuhsatArama(e.target.value)} placeholder="Ruhsat no veya işyeri adı..."
                    className="search-input" onKeyDown={e=>e.key==='Enter'&&(e.preventDefault(),ruhsatAra())} style={{flex:1}} />
                  <button type="button" className="btn btn-outline" onClick={ruhsatAra}>Ara</button>
                </div>
                {ruhsatSonuc.length>0&&(
                  <div style={{border:'1px solid #ddd',borderRadius:'4px',marginTop:'4px',maxHeight:'130px',overflowY:'auto',background:'#fff'}}>
                    {ruhsatSonuc.map(r=>(
                      <div key={r.id} onClick={()=>{setForm(f=>({...f,ruhsat_id:r.id}));setRuhsatArama(`${r.rn} — ${r.unvan}`);setRuhsatSonuc([]);}}
                        style={{padding:'8px 12px',cursor:'pointer',borderBottom:'1px solid #f0f0f0',fontSize:'13px'}}
                        onMouseOver={e=>e.currentTarget.style.background='#f5f5ff'} onMouseOut={e=>e.currentTarget.style.background='#fff'}>
                        <strong>{r.rn}</strong> — {r.unvan}
                      </div>
                    ))}
                  </div>
                )}
                {form.ruhsat_id && <div style={{fontSize:'12px',color:'#1b5e20',marginTop:'4px'}}>✅ Seçildi</div>}
              </div>
              <div className="form-grid">
                <div className="form-group">
                  <label>Planlanan Tarih *</label>
                  <input type="datetime-local" value={form.planlanan_tarih} onChange={e=>setForm({...form,planlanan_tarih:e.target.value})} required />
                </div>
                <div className="form-group">
                  <label>Denetim Türü</label>
                  <select value={form.tur} onChange={e=>setForm({...form,tur:e.target.value})}>
                    <option value="">Seçin...</option>
                    <option value="RUTIN">Rutin</option>
                    <option value="SIKAYET">Şikayete Bağlı</option>
                    <option value="YENILEME">Yenileme</option>
                    <option value="ACIL">Acil</option>
                    <option value="TAKIP">Takip</option>
                  </select>
                </div>
                <div className="form-group" style={{gridColumn:'1/-1'}}>
                  <label>Atanan Personel</label>
                  <select value={form.atanan_personel_id} onChange={e=>setForm({...form,atanan_personel_id:e.target.value})}>
                    <option value="">Seçin (opsiyonel)</option>
                    {personeller.map(p=><option key={p.id} value={p.id}>{p.ad_soyad} ({p.rol})</option>)}
                  </select>
                </div>
                <div className="form-group" style={{gridColumn:'1/-1'}}>
                  <label>Notlar</label>
                  <textarea value={form.notlar} onChange={e=>setForm({...form,notlar:e.target.value})} rows={2} />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setModalAcik(false)}>İptal</button>
                <button type="submit" className="btn btn-primary" disabled={!form.ruhsat_id||!form.planlanan_tarih}>Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
